import { Action, createReducer, on } from '@ngrx/store';

import {
  tramiteCreate,
  tramiteDelete,
  tramiteGet,
  tramiteGetRequest,
  tramiteGetSuccess
} from './tramite.actions';
import {
  TramiteState,
  tramiteAdapter,
  tramiteInitialState
} from './tramite.state';

export const TRAMITE_FEATURE_KEY = 'tramite';

const reducer = createReducer(
  tramiteInitialState,
  on(tramiteCreate, (state) => ({
    ...state,
    isLoading: true,
    error: null
  })),
  on(tramiteGet, (state) => ({
    ...state,
    isLoading: true,
    error: null
  })),
  on(tramiteGetRequest, (state) => ({
    ...state,
    isLoading: true,
    error: null
  })),
  on(tramiteGetSuccess, (state, { items }) =>
    tramiteAdapter.setAll(items, {
      ...state,
      isLoading: false,
      error: null
    })
  ),
  on(tramiteDelete, (state) => ({
    ...state,
    isLoading: false,
    error: null
  }))
);

export function tramiteReducer(
  state: TramiteState | undefined,
  action: Action
) {
  return reducer(state, action);
}
